import api from 'core/util/api';
import { Measurement } from '@kentik/ui-shared/query/query.types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/measurements/nms') as Promise<Measurement[]>;

export const reconMeasurementsQuery = {
  queryKey: ['reconMeasurementsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<Measurement[], Error, Measurement[], readonly ['reconMeasurementsRaw']>;
